/**
 * Parse a YYYY-MM-DD date string as local date (not UTC)
 * This prevents timezone shift issues where dates appear as the previous day
 */
export function parseLocalDate(dateStr: string): Date {
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day);
}

/**
 * Format a YYYY-MM-DD date string for display, treating it as local date
 */
export function formatLocalDate(dateStr: string): string {
  return parseLocalDate(dateStr).toLocaleDateString();
}
